'use client';

import * as React from 'react';
import { type FC } from 'react';
import type { linkVariants } from '@paypoteam/page-components';
import { RouterLink } from '@paypoteam/page-components';
import type {
    AccordionItemProps,
    AccordionProps,
} from '@paypoteam/ui-components';
import {
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from '@paypoteam/ui-components';
import type { VariantProps } from 'class-variance-authority';
import Link from 'next/link';

import { cn } from '@/lib/utils';

import { NavigationLink } from '@/components/molecules/NavigationLink';

import type { NavMenuLinkItemType } from '@/types';

export interface MobileAccordionProps extends NavMenuLinkItemType {
    navigationLinkVariant: VariantProps<typeof linkVariants> & {
        className?: string;
    };
    navigationLinkClassName?: string;
    className?: string;
    variant?: AccordionItemProps['variant'];
    size?: AccordionProps['size'];
}

export const MobileAccordion: FC<MobileAccordionProps> = ({
    data,
    location,
    className,
    navigationLinkVariant,
    navigationLinkClassName,
    handleMenuClose,
    variant,
    size,
}) => {
    const { name, menu } = data;

    return (
        !!name && (
            <AccordionItem
                hover={'color'}
                variant={variant}
                value={name.toLowerCase().split(' ').join('-')}
            >
                <AccordionTrigger
                    className={cn('font-extrabold', className)}
                    size={size}
                >
                    {name}
                </AccordionTrigger>

                <AccordionContent className="p-0">
                    <ul>
                        {menu?.lead?.name && (
                            <li className="text-sm">
                                <RouterLink
                                    // @ts-ignore @TODO change types in lib page-components
                                    LinkElement={Link}
                                    linkData={menu.lead}
                                    variant={{
                                        color: 'active',
                                        states: 'enable',
                                    }}
                                    className={cn(
                                        'group/lead whitespace-nowrap pb-3',
                                        navigationLinkClassName,
                                    )}
                                    onClick={() => {
                                        // Sentry.addBreadcrumb({
                                        //     category: 'navigation',
                                        //     message:
                                        //         'click to menu link ' +
                                        //         menu.lead?.href,
                                        //     level: 'info',
                                        // });

                                        handleMenuClose && handleMenuClose();
                                    }}
                                />
                            </li>
                        )}

                        {menu?.list.map((el, i) => (
                            <li
                                key={`${el.href}_${i}`}
                                className="text-sm"
                            >
                                <NavigationLink
                                    scrollById={menu?.lead?.href === location}
                                    linkData={el}
                                    variant={navigationLinkVariant}
                                    className={cn(
                                        'w-full pb-3',
                                        navigationLinkClassName,
                                    )}
                                    onClick={() => {
                                        // Sentry.addBreadcrumb({
                                        //     category: 'navigation',
                                        //     message:
                                        //         'click to menu link ' + el.href,
                                        //     level: 'info',
                                        // });

                                        handleMenuClose && handleMenuClose();
                                    }}
                                />
                            </li>
                        ))}
                    </ul>
                </AccordionContent>
            </AccordionItem>
        )
    );
};
